import { LicenseManager } from 'ag-grid-enterprise';
import packageJson from 'package.json';

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

LicenseManager.setLicenseKey(
  'CompanyName=Neosperience S.p.A.,LicensedGroup=Neosperience,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-036986,SupportServicesEnd=18_January_2024_[v2]_MTcwNTUzNjAwMDAwMA==40aca2efd1936b1b05e7a40951e521bf'
);

if (environment.sentry.enabled) {
  Sentry.init({
    dsn: environment.sentry.dsn,
    environment: environment.env,
    integrations: [],
    release: packageJson.version,
    // Tracing
    // tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // tracePropagationTargets: environment.sentry.tracePropagationTargets,
  });
}

async function enableMocking(): Promise<void> {
  // Dev-serve only. PRODUCTION/MOCK are runtime config (env.js), so the hostname check is
  // the hard gate that keeps MSW off deployed environments.
  if (!/^(localhost|127\.)/.test(window.location.hostname)) return;
  if (window.__env?.['MOCK'] !== 'true') return;
  const [
    { startMockWorker, featureFlagOverrideHandlers },
    { projectMockHandlers, studyMockHandlers, crossSellingMockHandlers },
  ] = await Promise.all([import('@mitsubishi/shared/mocking'), import('@mitsubishi/project/data-access/mocks')]);
  await startMockWorker([
    ...featureFlagOverrideHandlers,
    ...projectMockHandlers,
    ...studyMockHandlers,
    ...crossSellingMockHandlers,
  ]);
}

enableMocking()
  .catch(err => console.error(err))
  .then(() => platformBrowserDynamic().bootstrapModule(AppModule))
  .then(() => {
    setTimeout(() => {
      const loadingElement = document.getElementById('startup-loader');
      if (loadingElement) {
        loadingElement.remove();
      }
    }, 500);
  })
  .catch(err => console.error(err));
